import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const STAGGER = 0.25;
const IMAGE_DELAY = 0.3;

export function topTrouble() {
  const prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  if (prefersReducedMotion) return;

  const listsContainer = document.querySelector(".p-trouble__lists");
  const imageBlock = document.querySelector(".p-trouble__imageBlock");
  if (!listsContainer) return;

  const items = listsContainer.querySelectorAll(".p-trouble__list");
  if (!items.length) return;

  const showImageBlock = () => {
    if (!imageBlock) return;

    gsap.fromTo(
      imageBlock,
      { autoAlpha: 0 },
      {
        autoAlpha: 1,
        duration: 0.8,
        ease: "power2.out",
        delay: IMAGE_DELAY,
      }
    );
  };

  const init = () => {
    const mm = gsap.matchMedia();

    // PC: 最後の list 発火から 0.3 秒後に imageBlock を表示
    mm.add("(min-width: 769px)", () => {
      ScrollTrigger.create({
        trigger: listsContainer,
        start: "top 85%",
        once: true,
        onEnter: () => {
          const tl = gsap.timeline();

          tl.fromTo(
            items,
            { autoAlpha: 0, y: -30 },
            {
              autoAlpha: 1,
              y: 0,
              duration: 0.8,
              ease: "power2.out",
              stagger: STAGGER,
            }
          );

          if (imageBlock) {
            tl.fromTo(
              imageBlock,
              { autoAlpha: 0 },
              {
                autoAlpha: 1,
                duration: 0.8,
                ease: "power2.out",
              },
              (items.length - 1) * STAGGER + IMAGE_DELAY
            );
          }
        },
      });
    });

    // SP: 全 list が発火してから 0.3 秒後に imageBlock を表示
    mm.add("(max-width: 768px)", () => {
      let firedCount = 0;

      items.forEach((item) => {
        ScrollTrigger.create({
          trigger: item,
          start: "top 90%",
          once: true,
          onEnter: () => {
            gsap.fromTo(
              item,
              { autoAlpha: 0, y: -30 },
              {
                autoAlpha: 1,
                y: 0,
                duration: 0.8,
                ease: "power2.out",
              }
            );

            firedCount += 1;
            if (firedCount === items.length) {
              showImageBlock();
            }
          },
        });
      });
    });

    ScrollTrigger.refresh();
  };

  if (document.readyState === "complete") {
    init();
  } else {
    window.addEventListener("load", init, { once: true });
  }
}
